import { render } from "./empty-layout.vue?vue&type=template&id=015c04e0"
import script from "./empty-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./empty-layout.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/empty-layout/empty-layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "015c04e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('015c04e0', __exports__)) {
    api.reload('015c04e0', __exports__)
  }
  
  module.hot.accept("./empty-layout.vue?vue&type=template&id=015c04e0", () => {
    api.rerender('015c04e0', render)
  })

}


export default __exports__